module.exports = __webpack_public_path__ + "img/pma_menu.210c3722.svg";